import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import CurrentPlaceIcon from "../assets/icons/current_place.svg";

import SelectCategoryButton from "./SelectCategoryButton";

import WaitingImage from "../assets/img/temp.jpeg";

import SelectAll from "../assets/icons/select_all.svg";
import SelectExh from "../assets/icons/select_exhibitions.svg";
import SelectExp from "../assets/icons/select_experiences.svg";
import SelectSht from "../assets/icons/select_convenients.svg";
import SelectEtc from "../assets/icons/select_etcs.svg";
import UnselectAll from "../assets/icons/unselect_all.svg";
import UnselectExh from "../assets/icons/unselect_exhibitions.svg";
import UnselectExp from "../assets/icons/unselect_experiences.svg";
import UnselectCon from "../assets/icons/unselect_convenients.svg";
import UnselectEtc from "../assets/icons/unselect_etcs.svg";

import ExhBtn from "../assets/icons/btnExh.svg";
import ExhEnBtn from "../assets/icons/btnExh_en.svg";
import ExpBtn from "../assets/icons/btnExp.svg";
import ExpEnBtn from "../assets/icons/btnExp_en.svg";
import ShtBtn from "../assets/icons/btnCon.svg";
import ShtEnBtn from "../assets/icons/btnCon_en.svg";
import EtcBtn from "../assets/icons/btnEtc.svg";
import EtcEnBtn from "../assets/icons/btnEtc_en.svg";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const gridSide = "calc(50vw - 22px)";
const TextCurrentPlace = styled.span`
  color: var(--neutral-1-on-background-on-surface, #262d39);
  font-feature-settings: "liga" off, "clig" off;

  /* body2_14 */
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`;
const TextGuideWhereToGo = styled.div`
  color: var(--neutral-1-on-background-on-surface, #262d39);
  font-feature-settings: "liga" off, "clig" off;

  /* Headline_18B */
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 133.333% */
  margin-top: 4px;
`;

const ListAll = ({
  isBannerVisible,
  all,
  exhibitions,
  experiences,
  shuttles,
  etcs,
  showPath,
}) => {
  const { t, i18n } = useTranslation();
  const startPoint = JSON.parse(sessionStorage.getItem("startPoint"));

  const [category, setCategory] = useState(0);
  const bannerHeight = isBannerVisible ? "82px" : "0";

  // const [isLoading, setIsLoading] = useState(true);
  // useEffect(() => {
  //   setIsLoading(false);
  // }, []);

  return (
    <div
      style={{
        position: "absolute",
        top: "146px",
        width: "100%",
      }}
    >
      {/* Category buttons */}
      <div
        style={{
          backgroundColor: "white",
          paddingTop: "16px",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            width: "100%",
          }}
        >
          <SelectCategoryButton
            selectIcon={SelectAll}
            unselectIcon={UnselectAll}
            categoryName={t("listAll.total")} // "전체"
            onSelectCategory={() => setCategory(0)}
            isSelected={0 === category}
          />
          <SelectCategoryButton
            selectIcon={SelectExh}
            unselectIcon={UnselectExh}
            categoryName={t("listAll.exhibitions")} // 본전시
            onSelectCategory={() => setCategory(1)}
            isSelected={1 === category}
          />
          <SelectCategoryButton
            selectIcon={SelectExp}
            unselectIcon={UnselectExp}
            categoryName={t("listAll.experiences")} // 파빌리온
            onSelectCategory={() => setCategory(2)}
            isSelected={2 === category}
          />
          <SelectCategoryButton
            selectIcon={SelectSht}
            unselectIcon={UnselectCon}
            categoryName={t("listAll.shuttles")} // 셔틀버스
            onSelectCategory={() => setCategory(3)}
            isSelected={3 === category}
          />
        </div>
      </div>

      <div style={{ backgroundColor: "#EEEFF3", height: "1px" }} />
      {startPoint && (
        <div style={{ padding: "26px 16px 0px 16px" }}>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <img src={CurrentPlaceIcon} alt="현위치"></img>
            <TextCurrentPlace>
              {t("listAll.currentPlace")}
              {startPoint.name[i18n.language]}
            </TextCurrentPlace>
          </div>
          <TextGuideWhereToGo>{t("listAll.GuideWhereToGo")}</TextGuideWhereToGo>
        </div>
      )}

      {/* Places */}
      <div style={{ padding: "18px 16px" }}>
        <ul
          style={{
            gridTemplateColumns: "auto auto",
            display: "grid",
            // overflowY: "auto",
            listStyle: "none",
            margin: `auto auto ${bannerHeight} auto`,
            padding: "0",
            gap: "12px",
          }}
        >
          {category === 0 &&
            all.map((place) => {
              const region = place.name["ko-KR"].split(" ")[0];
              return (
                <Link
                  to={
                    place.i === 32 ||
                    place.i === 33 ||
                    place.i === 34 ||
                    place.i === 35
                      ? `/shuttle-info?region=${region}&back=home`
                      : "detail"
                  }
                  key={place.docId}
                  onClick={() => {
                    sessionStorage.setItem("endPoint", JSON.stringify(place));
                  }}
                  style={{
                    textDecorationLine: "none",
                  }}
                >
                  <li
                    style={{
                      gridColumnEnd: "span 1",
                      gridRowEnd: "span 1",
                      width: gridSide,
                      height: gridSide,
                      borderRadius: "12px",
                      boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
                    }}
                  >
                    <div
                      style={{
                        objectFit: "cover",
                        width: "100%",
                        height: "calc(100% - 55px)",
                        borderRadius: "12px 12px 0 0",
                        position: "relative",
                      }}
                    >
                      <img
                        src={
                          place.img && place.img !== ""
                            ? place.img
                            : WaitingImage
                        }
                        alt={place.name[i18n.language]}
                        style={{
                          objectFit: "cover",
                          width: "100%",
                          height: "100%",
                          borderRadius: "12px 12px 0 0",
                        }}
                      />

                      <div
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "10px",
                        }}
                      >
                        {place.category === 1 && (
                          <img
                            src={i18n.language === "ko-KR" ? ExhBtn : ExhEnBtn}
                            alt="본전시"
                          />
                        )}
                        {place.category === 2 && (
                          <img
                            src={i18n.language === "ko-KR" ? ExpBtn : ExpEnBtn}
                            alt="파빌리온"
                          />
                        )}
                        {place.category === 3 && (
                          <img
                            src={i18n.language === "ko-KR" ? ShtBtn : ShtEnBtn}
                            alt="셔틀버스"
                          />
                        )}
                        {place.category === 4 && (
                          <img
                            src={i18n.language === "ko-KR" ? EtcBtn : EtcEnBtn}
                            alt="기타"
                          />
                        )}
                      </div>
                    </div>
                    <div
                      style={{
                        left: 0,
                        bottom: 0,
                        backgroundColor: "white",
                        width: "calc(100% - 24px)",
                        padding: "12px",
                        borderRadius: "0 0 11px 11px",
                      }}
                    >
                      <div
                        style={{
                          color: "#282D4B",
                          fontSize: "13px",
                          whiteSpace: "nowrap",
                          fontWeight: 500,
                          overflow: "hidden",
                          textWrap: "wrap",
                          textOverflow: "ellipsis",
                          height: i18n.language === "ko-KR" ? "18px" : "32px",
                        }}
                      >
                        {place.name[i18n.language]}
                      </div>
                      {i18n.language === "ko-KR" && (
                        <div
                          style={{
                            color: "#9A9CAD",
                            fontSize: "12px",

                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {place.simple_address[i18n.language]}
                        </div>
                      )}
                    </div>
                  </li>
                </Link>
              );
            })}
          {category === 1 &&
            exhibitions.map((place) => {
              return (
                <Link
                  to="detail"
                  key={place.docId}
                  onClick={() => {
                    sessionStorage.setItem("endPoint", JSON.stringify(place));
                  }}
                  style={{
                    textDecorationLine: "none",
                  }}
                >
                  <li
                    style={{
                      gridColumnEnd: "span 1",
                      gridRowEnd: "span 1",
                      width: gridSide,
                      height: gridSide,
                      borderRadius: "12px",
                      boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
                    }}
                  >
                    <div
                      style={{
                        objectFit: "cover",
                        width: "100%",
                        height: "calc(100% - 55px)",
                        borderRadius: "12px 12px 0 0",
                        position: "relative",
                      }}
                    >
                      <img
                        src={
                          place.img && place.img !== ""
                            ? place.img
                            : WaitingImage
                        }
                        alt={place.name[i18n.language]}
                        style={{
                          objectFit: "cover",
                          width: "100%",
                          height: "100%",
                          borderRadius: "12px 12px 0 0",
                        }}
                      />

                      <div
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "10px",
                        }}
                      >
                        <img
                          src={i18n.language === "ko-KR" ? ExhBtn : ExhEnBtn}
                          alt="본전시"
                        />
                      </div>
                    </div>
                    <div
                      style={{
                        left: 0,
                        bottom: 0,
                        backgroundColor: "white",
                        width: "calc(100% - 24px)",
                        padding: "12px",
                        borderRadius: "0 0 11px 11px",
                      }}
                    >
                      <div
                        style={{
                          color: "#282D4B",
                          fontSize: "13px",
                          whiteSpace: "nowrap",
                          fontWeight: 500,
                          overflow: "hidden",
                          textWrap: "wrap",
                          textOverflow: "ellipsis",
                          height: i18n.language === "ko-KR" ? "18px" : "32px",
                        }}
                      >
                        {place.name[i18n.language]}
                      </div>
                      {i18n.language === "ko-KR" && (
                        <div
                          style={{
                            color: "#9A9CAD",
                            fontSize: "12px",

                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {place.simple_address[i18n.language]}
                        </div>
                      )}
                    </div>
                  </li>
                </Link>
              );
            })}
          {category === 2 &&
            experiences.map((place) => {
              return (
                <Link
                  to="detail"
                  key={place.docId}
                  onClick={() => {
                    sessionStorage.setItem("endPoint", JSON.stringify(place));
                  }}
                  style={{
                    textDecorationLine: "none",
                  }}
                >
                  <li
                    style={{
                      gridColumnEnd: "span 1",
                      gridRowEnd: "span 1",
                      position: "relative",
                      width: gridSide,
                      height: gridSide,

                      borderRadius: "12px",
                      boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
                    }}
                  >
                    <div
                      style={{
                        objectFit: "cover",
                        width: "100%",
                        height: "calc(100% - 55px)",
                        borderRadius: "12px 12px 0 0",
                        position: "relative",
                      }}
                    >
                      <img
                        src={
                          place.img && place.img !== ""
                            ? place.img
                            : WaitingImage
                        }
                        alt={place.name[i18n.language]}
                        style={{
                          objectFit: "cover",
                          width: "100%",
                          height: "100%",
                          borderRadius: "12px 12px 0 0",
                        }}
                      />

                      <div
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "10px",
                        }}
                      >
                        <img
                          src={i18n.language === "ko-KR" ? ExpBtn : ExpEnBtn}
                          alt="파빌리온"
                        />
                      </div>
                    </div>
                    <div
                      style={{
                        left: 0,
                        bottom: 0,
                        backgroundColor: "white",
                        width: "calc(100% - 24px)",
                        padding: "12px",
                        borderRadius: "0 0 11px 11px",
                      }}
                    >
                      <div
                        style={{
                          color: "#282D4B",
                          fontSize: "13px",
                          whiteSpace: "nowrap",
                          fontWeight: 500,
                          overflow: "hidden",
                          textWrap: "wrap",
                          textOverflow: "ellipsis",
                          height: i18n.language === "ko-KR" ? "18px" : "32px",
                        }}
                      >
                        {place.name[i18n.language]}
                      </div>
                      {i18n.language === "ko-KR" && (
                        <div
                          style={{
                            color: "#9A9CAD",
                            fontSize: "12px",

                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {place.simple_address[i18n.language]}
                        </div>
                      )}
                    </div>
                  </li>
                </Link>
              );
            })}
          {category === 3 &&
            shuttles.map((place) => {
              const region = place.name["ko-KR"].split(" ")[0];
              return (
                <Link
                  to={`/shuttle-info?region=${region}&back=home`}
                  key={place.docId}
                  onClick={() => {
                    sessionStorage.setItem("endPoint", JSON.stringify(place));
                  }}
                  style={{
                    textDecorationLine: "none",
                  }}
                >
                  <li
                    style={{
                      gridColumnEnd: "span 1",
                      gridRowEnd: "span 1",
                      position: "relative",
                      width: gridSide,
                      height: gridSide,

                      borderRadius: "12px",
                      boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
                    }}
                  >
                    <div
                      style={{
                        objectFit: "cover",
                        width: "100%",
                        height: "calc(100% - 55px)",
                        borderRadius: "12px 12px 0 0",
                        position: "relative",
                      }}
                    >
                      <img
                        src={
                          place.img && place.img !== ""
                            ? place.img
                            : WaitingImage
                        }
                        alt={place.name[i18n.language]}
                        style={{
                          objectFit: "cover",
                          width: "100%",
                          height: "100%",
                          borderRadius: "12px 12px 0 0",
                        }}
                      />

                      <div
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "10px",
                        }}
                      >
                        <img
                          src={i18n.language === "ko-KR" ? ShtBtn : ShtEnBtn}
                          alt="셔틀버스"
                        />
                      </div>
                    </div>
                    <div
                      style={{
                        left: 0,
                        bottom: 0,
                        backgroundColor: "white",
                        width: "calc(100% - 24px)",
                        padding: "12px",
                        borderRadius: "0 0 11px 11px",
                      }}
                    >
                      <div
                        style={{
                          color: "#282D4B",
                          fontSize: "13px",
                          whiteSpace: "nowrap",
                          fontWeight: 500,
                          overflow: "hidden",
                          textWrap: "wrap",
                          textOverflow: "ellipsis",
                          height: i18n.language === "ko-KR" ? "18px" : "32px",
                        }}
                      >
                        {place.name[i18n.language]}
                      </div>
                      {i18n.language === "ko-KR" && (
                        <div
                          style={{
                            color: "#9A9CAD",
                            fontSize: "12px",

                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {place.simple_address[i18n.language]}
                        </div>
                      )}
                    </div>
                  </li>
                </Link>
              );
            })}
          {category === 4 &&
            etcs.map((place) => {
              return (
                <Link
                  to="detail"
                  key={place.docId}
                  onClick={() => {
                    sessionStorage.setItem("endPoint", JSON.stringify(place));
                  }}
                  style={{
                    textDecorationLine: "none",
                  }}
                >
                  <li
                    style={{
                      gridColumnEnd: "span 1",
                      gridRowEnd: "span 1",
                      position: "relative",
                      width: gridSide,
                      height: gridSide,
                      borderRadius: "12px",
                      boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
                    }}
                  >
                    <div
                      style={{
                        objectFit: "cover",
                        width: "100%",
                        height: "calc(100% - 55px)",
                        borderRadius: "12px 12px 0 0",
                        position: "relative",
                      }}
                    >
                      <img
                        src={
                          place.img && place.img !== ""
                            ? place.img
                            : WaitingImage
                        }
                        alt={place.name[i18n.language]}
                        style={{
                          objectFit: "cover",
                          width: "100%",
                          height: "100%",
                          borderRadius: "12px 12px 0 0",
                        }}
                      />

                      <div
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "10px",
                        }}
                      >
                        <img
                          src={i18n.language === "ko-KR" ? EtcBtn : EtcEnBtn}
                          alt="기타"
                        />
                      </div>
                    </div>
                    <div
                      style={{
                        left: 0,
                        bottom: 0,
                        backgroundColor: "white",
                        width: "calc(100% - 24px)",
                        padding: "12px",
                        borderRadius: "0 0 11px 11px",
                      }}
                    >
                      <div>{place.category}</div>
                      <div
                        style={{
                          color: "#282D4B",
                          fontSize: "13px",
                          whiteSpace: "nowrap",
                          fontWeight: 500,
                          overflow: "hidden",
                          textWrap: "wrap",
                          textOverflow: "ellipsis",
                          height: i18n.language === "ko-KR" ? "18px" : "32px",
                        }}
                      >
                        {place.name[i18n.language]}
                      </div>
                      {i18n.language === "ko-KR" && (
                        <div
                          style={{
                            color: "#9A9CAD",
                            fontSize: "12px",

                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {place.simple_address[i18n.language]}
                        </div>
                      )}
                    </div>
                  </li>
                </Link>
              );
            })}
        </ul>
      </div>
    </div>
  );
};

ListAll.propTypes = {
  isBannerVisible: PropTypes.bool,
  all: PropTypes.array,
  exhibitions: PropTypes.array,
  experiences: PropTypes.array,
  shuttles: PropTypes.array,
  etcs: PropTypes.array,
  showPath: PropTypes.func,
};

export default ListAll;
